import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Utility to determine if the app is running as a native app (iOS/Android) 
 * via Capacitor, or if it's running in a web browser.
 */
export const isNativeApp = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Open OAuth connect URL for Strava or other providers.
 * If running on native iOS/Android, opens via Capacitor Browser (SFSafariViewController)
 * passing platform=ios so the backend redirects to the custom scheme nousmetrics://.
 */
export const connectProvider = async (provider, userId, apiUrl) => {
  const isNative = Capacitor.isNativePlatform();
  const platformParam = isNative ? '&platform=ios' : '';
  const connectUrl = `${apiUrl}/auth/${provider}/connect?userId=${userId}${platformParam}`;
  
  if (isNative) {
    try {
      await Browser.open({ url: connectUrl, windowName: '_system' });
    } catch (err) {
      console.warn('[OAuth] Browser.open error, fallback to window.location:', err);
      window.location.href = connectUrl;
    }
  } else {
    window.location.href = connectUrl;
  }
};

